import { useMutation, useQueryClient } from 'react-query'
import { updateProject } from 'api/services/updateProject'

export const useUpdateProject = (projectId, options = {}) => {
  const queryClient = useQueryClient()
  const { onSuccess = () => {} } = options

  return useMutation((data) => updateProject(projectId, data), {
    ...options,
    onSuccess: (data) => {
      queryClient.invalidateQueries('projects')
      onSuccess(data)
    },
  })
}
